import type { BracketMatch, PickemTeam } from '../types'
import { getBracketSlotDisplayTeam } from './bracket-slot-display'

/** Команда в колонке «Победитель» из матча GF. */
export const getBracketGfWinner = (
  match: BracketMatch,
  resultsView: boolean
): PickemTeam | null => {
  if (resultsView) {
    if (!match.outcome_side) return null
    const slot = match.slots.find(s => s.side === match.outcome_side)
    return slot?.team ?? null
  }

  if (match.user_pick_team_id) {
    for (const slot of match.slots) {
      const team = getBracketSlotDisplayTeam(slot, resultsView)
      if (team?.id === match.user_pick_team_id) return team
    }
  }

  return null
}
